import { ComponentGenerator, WorkflowScreen } from './workflow-screen';

export class WorkflowAssessorScreen extends WorkflowScreen {
    public cansShowFromHorizon = () => {
        return false;
    };

    public readonly icon: string;
    public constructor(
        label: string,
        icon: string,
        component?: React.ComponentType<any> | ComponentGenerator,
        parent?: WorkflowScreen,
        screenHeading?: string,
        canShow?: () => boolean
    ) {
        super(label, component, parent, screenHeading, canShow);
        this.icon = icon;
    }

    public cloneWithNewParent(parent?: WorkflowScreen) {
        return new WorkflowAssessorScreen(
            this.label,
            this.icon,
            this.component,
            parent,
            this.screenHeading,
            parent?.label === 'Death' || parent?.label === 'Funeral' || parent?.label === 'RA Death'
                ? this.cansShowFromHorizon
                : this.canShow
        );
    }
}
